import { render } from "./WebHeader.vue?vue&type=template&id=a596b07a&scoped=true"
import script from "./WebHeader.vue?vue&type=script&lang=js"
export * from "./WebHeader.vue?vue&type=script&lang=js"

import "./WebHeader.vue?vue&type=style&index=0&id=a596b07a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a596b07a"]])

export default __exports__